import { DEFINITIONS as TITLE_DEFINITIONS } from '@xingternal/content-editor-plugin-title';
import { DEFINITIONS as SUMMARY_DEFINTIIONS } from '@xingternal/content-editor-plugin-summary';

import {
  Serializer,
  titleSerializer,
  textSerializer,
  summarySerializer,
  TITLE_TYPENAME,
  SUMMARY_TYPENAME,
} from './index';

class ArticleHeaderSerializer {
  articleHeaderSerializer = null;

  constructor() {
    this.articleHeaderSerializer = new Serializer({
      nodeSerializers: [titleSerializer, textSerializer, summarySerializer],
      markSerializers: [],
    });
  }

  serialize(blocks) {
    const [title, summary] = this.articleHeaderSerializer.serialize(
      blocks.filter(
        (block) =>
          (block && block.type === TITLE_DEFINITIONS.type) ||
          (block && block.type === SUMMARY_DEFINTIIONS.type)
      )
    );

    return { ...title, ...summary };
  }

  deserialize(blocks) {
    const [title, summary] = this.articleHeaderSerializer.deserialize(
      blocks.filter(
        (block) =>
          (block && block.__typename === TITLE_TYPENAME) ||
          (block && block.__typename === SUMMARY_TYPENAME)
      )
    );
    return { title, summary };
  }
}

const articleHeaderSerializer = new ArticleHeaderSerializer();

export { articleHeaderSerializer };
